module.exports = __webpack_public_path__ + "0311f4b4784d49d4aedba4373d3a9a0e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/balloon-purple-heart-right.png
// module id = 2479
// module chunks = 0